function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1,0,0,1,4,10)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-4"
}, /*#__PURE__*/React.createElement("g", {
  id: "bars-light"
}, /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "M13.813,1.5L0.188,1.5C0.084,1.5 0,1.388 0,1.25L0,0.25C-0,0.112 0.084,0 0.188,0L13.813,0C13.916,0 14,0.112 14,0.25L14,1.25C14,1.388 13.916,1.5 13.813,1.5Z"
}))));
var SvgDashPass = function SvgDashPass(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 22 22",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDashPass, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dash-pass.481eb726.svg";
export { ForwardRef as ReactComponent };